import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { reportindex } from 'projects/icemedx-lib/src/models/reports/reportindex';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IBaseView } from '../../../../icemedx-lib/src/components/baseview.component';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { otheritemsindex } from '../../../../icemedx-lib/src/models/otheritems/otheritemsindex';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { otheritems } from '../../../../icemedx-lib/src/models/otheritems/otheritems';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { superbillchargesindex } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillchargesindex';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { otheritemsreceiving } from '../../../../icemedx-lib/src/models/otheritems/otheritemsreceiving';
import { purchasedelivery } from '../../../../icemedx-lib/src/models/accounting/medservice/purchasedelivery';
import { purchaseindex } from '../../../../icemedx-lib/src/models/accounting/medservice/purchaseindex';

const ItemKeyword = "ItemKeyword";
const BillingAction = "BillingAction";
const BillingActionDomainType = "BillingActionDomainType";
const BillingActionNameofDomain = "BillingActionNameofDomain";
const BillingActionDomainOrder = "BillingActionDomainOrder";
const BillingActionDomainItemEntry = "BillingActionDomainItemEntry";
const BillingActionDomainItemSubmit = "BillingActionDomainItemSubmit";

enum OrderActionType {
  oatNone = 0,
  oatReceiving = 1,
  oatCheckout = 2,
};

enum ItemActionType {
  oatEdit = 0,
  oatAddToOrder = 1,
  oatRemoveFromOrder = 2,
};

const itemQuickActionEdit = { name: "Edit", value: ItemActionType.oatEdit, iconClass: { "fas": true, "fa-edit": true, "fa-2x": true } };
const itemQuickActionAdd = { name: "Add to Statement", value: ItemActionType.oatAddToOrder, iconClass: { "fas": true, "fa-cart-plus": true, "fa-2x": true } };

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class InventoryComponent implements OnInit, IBaseView {
  // data members
  resultsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  orderItemsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  purchaseItemsDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  // member settings
  inventoryListSettings: IcepanelcontainerSettings = null;
  inventoryPermission: IcecontrolPermission = null;

  sectionTagNewItem: string = "NewItemSection";
  tableTagResults: string = "ResultsTable";
  tableTagOrderItems: string = "OrderItems";
  tableTagPurchaseItems: string = "PurchaseItems";
  resultsTable: IcemattableSettings = null;
  orderItemsTable: IcemattableSettings = null;
  purchaseItemsTable: IcemattableSettings = null;
  itemResultQuickAction: any[] = [];
  newItem: otheritemsindex = null;
  invNameCtrl: IcecontrolSettings = null;
  invCodeQualCtrl: IcecontrolSettings = null;
  invCodeCtrl: IcecontrolSettings = null;
  invUnitCtrl: IcecontrolSettings = null;

  //////////////////////
  // Search Controls
  private ctrlSearchInput: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "450px" }, null, null, ItemKeyword, "Enter Item Name or Number")
    .setControlName(ItemKeyword)
    .createFormControl("", [Validators.required]);
  private ctrlSearchSubmit: IcecontrolSettings = new IcecontrolSettings("icesubmitbutton", { class: "fas fa-paper-plane", width: "50px", text: "Search" }, null, null, "searchSubmit");
  private searchItemPanel: IcepanelSettings = this.createSearchItemPanel();

  //////////////////////
  // Order Info. Controls
  private ctrlBillingAction: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [{ value: OrderActionType.oatReceiving, name: "Receiving Item(s)" }, { value: OrderActionType.oatCheckout, name: "Checkout Item(s)" }], width: "100%" }, null, null, BillingAction, "Select Action")
    .setControlName(BillingAction)
    .createFormControl("", [Validators.required]);
  private ctrlBillingDomainType: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "100%" }, null, null, BillingActionDomainType, "Type of Bill") // Type of Receiving or Checkout Bill
    .setControlName(BillingActionDomainType)
    .createFormControl(0, [Validators.required]);
  private ctrlBillingDomainNameCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, BillingActionNameofDomain, "Enter Name of Network Domain") // ...Network Domain Bill To or From
    .setControlName(BillingActionNameofDomain)
  .createFormControl("", [Validators.required]);
  private ctrlBillingDomainOrderCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "100%" }, null, null, BillingActionDomainOrder, "Enter Service Charge Bucket No.") // ...Network Domain Bill Order No.
    .setControlName(BillingActionDomainOrder)
    .createFormControl("", [Validators.required]);
  private ctrlBillingDomainItemEntryCtrl = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, BillingActionDomainItemEntry, "Enter Item to Add to Charges.") 
    .setControlName(BillingActionDomainItemEntry)
    .createFormControl("", [Validators.required]);
  private ctrlBillingDomainItemSubmit = new IcecontrolSettings("icepanelbutton", { text: "Submit Item", class: [], glyphClass: "fa-plus" }, null, null, BillingActionDomainItemSubmit);

  private billingDomainSection: IcepanelsectionSettings = null;
  private billingDomainNameAndOrderSection: IcepanelsectionSettings = null;
  private billingPanel = this.createBillingPanel();
  private newOrder: any = { name: "Create New Service Bucket", value: "" };
  private noPurchaseOrder: any = { name: "No Purchase Order", value: "," };
  private unAssignedPurchasOrder: any = { name: "No Purchase Order Assigned", value: "" };

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private vendorSvc: VendorService,
    private patientSvc: PatientService,
    private proSvc: ProviderService,
    private pharmSvc: PharmacyService,
    private payerSvc: PayerService,
    private medCodeSvc: MedicalcodesService,
    private router: Router,
    private changeDetectorRefs: ChangeDetectorRef) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Inventory", {}, true, "");

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufOtherItemsSoldandServices).default_access;
    this.inventoryPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufOtherItemsSoldandServices, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
    }

    this.inventoryListSettings = this.viewSetup(new IceEntity());
  }

  getBreadcrumbs(): any {
    return this.appSvc.getBreadcrumbs();
  }

  getSearchItemFormGroup(): FormGroup {
    if (this.searchItemPanel == null)
      return null;

    let formGrp: FormGroup = this.searchItemPanel.getForm();
    try {
      if (formGrp == null) // to prevent from getting form error we create an empty group place
        formGrp = new FormGroup({});
    }
    catch (e) {
      console.log(e);
    }

    return formGrp;
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  createSearchItemPanel(): IcepanelSettings {
    let panel: IcepanelSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];

      controls.push(
        this.ctrlSearchInput,
      );
      headerControls.push(
        this.ctrlSearchSubmit,
      );

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("SearchItemSection", { class: [""], styles: { width: "100%" } }, null, controls, [])
      ];
      panel = new IcepanelSettings("SearchItemPanel", Iceutility.guid(false), "", "", sections, headerControls)
        .enableForm();

      this.ctrlSearchInput.setOptions([{ value: "TEST", name: "Hand"}]);
    }
    catch (e) {
      console.log(e);
    }
    return panel;
  }

  createBillingPanel(): IcepanelSettings {
    let panel: IcepanelSettings = null;
    try {
      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];

      controls.push(
        this.ctrlBillingAction,
      );
      headerControls.push(
        //this.ctrlSearchSubmit,
      );

      this.billingDomainSection = new IcepanelsectionSettings("BillingDomainPanelSection", { class: [""], styles: { width: "100%" } }, null, [
        this.ctrlBillingDomainType,
      ], []).setShow(false);

      let itemTables = this.viewOrderItemTables([], []);
      itemTables = itemTables.concat(this.viewPurchaseItemTables([], []));
      let itemGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, itemTables)
      ];

      this.billingDomainNameAndOrderSection = new IcepanelsectionSettings("BillingPanelNameAndOrderSection", { class: [""], styles: { width: "100%" } }, itemGroups, [
        this.ctrlBillingDomainNameCtrl,
        this.ctrlBillingDomainOrderCtrl,
        this.ctrlBillingDomainItemEntryCtrl,
        this.ctrlBillingDomainItemSubmit
      ], []).setShow(false);
      this.ctrlBillingDomainItemEntryCtrl.setReadonly(true);
      this.ctrlBillingDomainItemSubmit.setDisabled(true);

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("BillingPanelSection", { class: [""], styles: { width: "100%" } }, null, controls, []),
        this.billingDomainSection,
        this.billingDomainNameAndOrderSection
      ];
      panel = new IcepanelSettings("BillingPanel", Iceutility.guid(false), "Order Information", "", sections, headerControls)
        .enableForm();
    }
    catch (e) {
      console.log(e);
    }
    return panel;
  }

  private getSearchElementValue(): string {
    let ret = "";
    let frmKeyword: FormControl = this.ctrlSearchInput.getFormControl();
    if (Iceutility.isdefined(frmKeyword)) {
      let keywordElem = <HTMLInputElement>document.getElementById(ItemKeyword);
      if (keywordElem) {
        if (keywordElem.value.length == 0) {
          this.accSvc.logMessage(IceTypes.LOGTYPE.ltError, "Error: No search keyword entered.");
          return ret;
        }
        ret = keywordElem.value;
      }
    }
    return ret;
  }

  viewSetup(dat: IceEntity): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufOtherItemsSoldandServices).default_access;

      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
        return null;
      }
      if (dat == null) {
        return null;
      }

      /////////////////////////
      // 

      //////////////////////
      // Results
      let invTables = this.viewInventoryTables([], []);
      let invSections = this.viewInventorySection(invTables, [], true);

      let invfrm: IcepanelSettings = new IcepanelSettings("InventoryView", "", "Inventory", "", invSections, null, null)
        .enableForm();

      let nameFrmGrp = invfrm.getForm();
      let panels: IcepanelSettings[] = [
        invfrm,
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("InventoryViewContainer", panelrows);
    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  viewInventoryTables(results: any[], codes: string[]): IcemattableSettings[] {
    let tables: IcemattableSettings[] = [];
    try {
      this.resultsTable = new IcemattableSettings(
        this.tableTagResults,
        [
          new iceColumnDefinition("itm_name", "Name of Item", false, false,
            new IcecontrolSettings("icelabel", { width: "200px" }, null, null)),
          new iceColumnDefinition("item_stock_num", "Item No", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Stock No.", width: "100px" }, null, null)),
          new iceColumnDefinition("sku_num", "SKU. No", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "SKU No.", width: "75px" }, null, null)),
          new iceColumnDefinition("code", "Medical Code", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Medical Code", width: "100px" }, null, null)),
          new iceColumnDefinition("code_list_qualifier_code", "Code Type", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Service Code", width: "100px" }, null, null)),
          new iceColumnDefinition("price", "Price", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Price", width: "50px" }, null, null)),
          new iceColumnDefinition("unit_type", "Unit", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Unit", width: "100px" }, null, null)),
          new iceColumnDefinition("other_items_key", "other_items_key", true),
          new iceColumnDefinition("code_object", "code_object", false, true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.resultsDataSource,
        [],
        false,
        null,
        true
      ).showAddButton(true);

      tables.push(this.resultsTable);

      if (results != null && results.length > 0) {
        this.resultsDataSource.data = results;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewOrderItemTables(items: any[], codes: string[]): IcemattableSettings[] {
    let tables: IcemattableSettings[] = [];
    try {
      this.orderItemsTable = new IcemattableSettings(
        this.tableTagOrderItems,
        [
          new iceColumnDefinition("item_abstract", "Item", false, false,
            new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
          new iceColumnDefinition("quantity", "Qty", false, false,
            new IcecontrolSettings("iceinput", { placeholder: "Qty.", width: "50px" }, null, null)),
          new iceColumnDefinition("price", "Rate", false, false,
            new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
          new iceColumnDefinition("unit_code", "Unit", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Unit", width: "100px" }, null, null)),
          new iceColumnDefinition("total_amount", "Total", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Total", width: "50px" }, null, null)),
          new iceColumnDefinition("medical_service_reference_key", "medical_service_reference_key", true),
          new iceColumnDefinition("medical_service_key", "medical_service_key", true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.orderItemsDataSource,
        [
          { name: "Remove from Order", value: ItemActionType.oatRemoveFromOrder, iconClass: { "fas": true, "fa-minus-circle": true } }
        ],
        false,
        null,
        true
      );

      tables.push(this.orderItemsTable);

      if (items != null && items.length > 0) {
        this.orderItemsDataSource.data = items;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewPurchaseItemTables(items: any[], codes: string[]): IcemattableSettings[] {
    let tables: IcemattableSettings[] = [];
    try {
      this.purchaseItemsTable = new IcemattableSettings(
        this.tableTagPurchaseItems,
        [
          new iceColumnDefinition("item_abstract", "Item", false, false,
            new IcecontrolSettings("icelabel", { width: "150px" }, null, null)),
          new iceColumnDefinition("quantity", "Qty", false, false,
            new IcecontrolSettings("iceinput", { placeholder: "Qty.", width: "50px" }, null, null)),
          new iceColumnDefinition("cost", "Rate", false, false,
            new IcecontrolSettings("iceinput", { placeholder: "Rate", width: "50px" }, null, null)),
          new iceColumnDefinition("unit_type", "Unit", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Unit", width: "100px" }, null, null)),
          new iceColumnDefinition("total_amount", "Total", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Total", width: "50px" }, null, null)),
          new iceColumnDefinition("other_items_receiving_key", "other_items_receiving_key", true),
          new iceColumnDefinition("other_items_key", "other_items_key", true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.purchaseItemsDataSource,
        [
          { name: "Remove from Order", value: ItemActionType.oatRemoveFromOrder, iconClass: { "fas": true, "fa-minus-circle": true } }
        ],
        false,
        null,
        true
      );

      tables.push(this.purchaseItemsTable);

      if (items != null && items.length > 0) {
        this.purchaseItemsDataSource.data = items;
      }
    }
    catch (e) {
      console.log(e);
    }
    return tables;
  }

  viewInventorySection(tables: IcemattableSettings[], idCodeList: string[], editMode: boolean): IcepanelsectionSettings[] {
    let sections: IcepanelsectionSettings[] = [];
    try {
      /// Item New Panel
      this.invNameCtrl = new IcecontrolSettings("iceinput", { width: "475px" }, null, null, "itm_name", "Enter Name of Item")
        .setControlName("itm_name")
        .createFormControl("", [Validators.required]);

      this.invCodeQualCtrl = new IcecontrolSettings("iceselect", { menuItems: MedicalcodesService.getMedicalCodeTypeList(), width: "475px" }, null, null, "code_list_qualifier_code", "Select Code Type")
        .setControlName("code_list_qualifier_code")
        .createFormControl("", []);

      this.invCodeCtrl = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "475px" }, null, null, "code_object", "Enter Medical Code")
        .setControlName("code_object")
        .createFormControl("", []);

      this.invUnitCtrl = new IcecontrolSettings("iceselect", { menuItems: [], width: "475px" }, null, null, "unit_type", "Select Unit")
        .setControlName("unit_type")
        .createFormControl("", [Validators.required]);

      let idControls = [
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "item_stock_num", "Enter Stock Num")
          .setControlName("item_stock_num")
          .createFormControl(Iceutility.guid(true).substr(0, 10).toUpperCase(), [Validators.required]),
        this.invNameCtrl,
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "sku_num", "Enter SKU Num")
          .setControlName("sku_num")
          .createFormControl("", []),
        this.invCodeQualCtrl,
        this.invCodeCtrl,
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "price", "Enter Price")
          .setControlName("price")
          .createFormControl(0, [Validators.required]),
        new IcecontrolSettings("iceinput", { width: "200px" }, null, null, "cost", "Enter Cost")
          .setControlName("cost")
          .createFormControl(0, [Validators.required]),
        this.invUnitCtrl,
      ];

      sections.push(this.appSvc.viewEditPanelSection(this.sectionTagNewItem, idControls));

      let resultsGroups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, tables)
      ];

      sections.push(
        new IcepanelsectionSettings("InventoryResultsViewSection", { class: ["yalla"], styles: { width: "100%" } }, resultsGroups, [], null)
      );

      this.appSvc.setCodeList(this.medCodeSvc, new basecode("QUANTITYUNITOFMEASURE"), this.invUnitCtrl, []);
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, []);
      this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, []);
    }
    catch (e) {
      console.log(e);
    }
    return sections;
  }

  viewActionItemClick(event, item) {

  }

  viewMoreActionItemsClick(event) {

  }

  getPostControlValue(panel, attru) {

  }

  getBillingAction(): OrderActionType {
    let ret: OrderActionType = OrderActionType.oatNone;
    let ctrAction: FormControl = this.ctrlBillingAction.getFormControl();
    if (ctrAction != null) {
      ret = ctrAction.value;
    }

    return ret;
  }

  getBillingType(): IceTypes.ACCOUNT_TYPE {
    let ret: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.ctrlBillingDomainType.getFormControl();
    if (ctrType != null) {
      ret = ctrType.value;
    }
    return ret;
  }

  getBillingDomain(): any {
    let ret = null;
    let ordDomainControl: FormControl = this.ctrlBillingDomainNameCtrl.getFormControl();
    if (ordDomainControl != null && ordDomainControl.value != null && ordDomainControl.value.length > 0) {
      try {
        let domObj = JSON.parse(ordDomainControl.value);
        if (domObj == null || domObj.length == 0) throw "Invalid order account selection.";
        ret = domObj;
      }
      catch (e) {
        console.log(e);
      }
    }
    return ret;
  }

  getBillingOrder(): any {
    let ret = null;
    let frmOrder: FormControl = this.ctrlBillingDomainOrderCtrl.getFormControl();
    if (frmOrder != null && frmOrder.value != null && frmOrder.value.length > 0) {
      try {
        let ordObj = JSON.parse(frmOrder.value);
        if (ordObj == null || ordObj.length == 0) throw "Invalid order selection.";
        ret = ordObj;
      }
      catch (e) {
        console.log(e);
      }
    }
    return ret;
  }

  updateItemSubmitControls(): void {
    let domObj = this.getBillingDomain();
    let ordObj = this.getBillingOrder();
    if (domObj != null && ordObj != null) {
      this.ctrlBillingDomainItemEntryCtrl.setReadonly(false);
      this.ctrlBillingDomainItemSubmit.setDisabled(false);
    }
    else {
      this.ctrlBillingDomainItemEntryCtrl.setReadonly(true);
      this.ctrlBillingDomainItemSubmit.setDisabled(true);
    }
  }

  setBillToOrders(billTo: string) {
    if (billTo == null || billTo.length == 0) return;

    this.accSvc.getBills(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billTo).subscribe(
      data => {
        if (data == null || data.length == 0) {
          return;
        }

        let bills: superbillchargesindex[] = <superbillchargesindex[]>data;

        let opts = bills.map(b => {
          let orddesc = Iceutility.isTextDateTime(b.created) ? Iceutility.getDateTextEx(b.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(b.created));
          orddesc += " - " + b.superbill_charges_key.substr(0, 10)
          return { value: b.superbill_charges_key, name: orddesc }
        });
        opts.push(this.newOrder);
        this.ctrlBillingDomainOrderCtrl.setOptions(opts);
      },
      error => {
        console.log(error);
      });
  }

  setPurchasesFrom(orderFrom: string) {
    if (orderFrom == null || orderFrom.length == 0) return;

    this.accSvc.getPurchases(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), orderFrom).subscribe(
      data => {
        if (data == null || data.length == 0) {
          return;
        }

        let purchases: purchaseindex[] = <purchaseindex[]>data;

        let opts = purchases.map(b => {
          let orddesc = Iceutility.isTextDateTime(b.created) ? Iceutility.getDateTextEx(b.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(b.created));
          orddesc += " - " + (b.purchase_order_number.length > 0 ? b.purchase_order_number : b.purchase_delivery_key.substr(0, 10))
          return { value: b.purchase_order_key + "," + b.purchase_delivery_key, name: orddesc }
        });
        opts.push(this.noPurchaseOrder);
        this.ctrlBillingDomainOrderCtrl.setOptions(opts);
      },
      error => {
        console.log(error);
      });
  }

  /////////////////////////////////////
  // Events
  onControlChange(event) {
    if (event.selectSettings != null) {
      switch (event.selectSettings.id) {
        case BillingAction: {
          switch (this.getBillingAction()) {
            case OrderActionType.oatCheckout: {
              this.ctrlBillingDomainType.getFormControl().setValue("");
              this.ctrlBillingDomainNameCtrl.getFormControl().setValue("");
              this.ctrlBillingDomainNameCtrl.setOptions([], true);
              this.ctrlBillingDomainOrderCtrl.getFormControl().setValue("");
              this.ctrlBillingDomainOrderCtrl.setOptions([this.newOrder], true);
              this.orderItemsDataSource.data = [];
              this.orderItemsDataSource.data = this.orderItemsDataSource.data;
              this.billingDomainSection.setShow(true);
              break;
            }
            case OrderActionType.oatReceiving: {
              this.ctrlBillingDomainType.getFormControl().setValue("");
              this.ctrlBillingDomainNameCtrl.getFormControl().setValue("");
              this.ctrlBillingDomainNameCtrl.setOptions([], true);
              this.ctrlBillingDomainOrderCtrl.getFormControl().setValue("");
              this.ctrlBillingDomainOrderCtrl.setOptions([this.noPurchaseOrder], true);
              this.orderItemsDataSource.data = [];
              this.orderItemsDataSource.data = this.orderItemsDataSource.data;
              this.billingDomainSection.setShow(true);
              break;
            }
          }
          if (this.getBillingType() != IceTypes.ACCOUNT_TYPE.actNone)
            this.billingDomainNameAndOrderSection.setShow(true);
          break;
        }
        case BillingActionDomainType: {
          this.billingDomainNameAndOrderSection.setShow(true);
          this.ctrlBillingDomainNameCtrl.getFormControl().setValue("");
          this.ctrlBillingDomainNameCtrl.setOptions([], true);
          this.ctrlBillingDomainOrderCtrl.getFormControl().setValue("");
          if (this.getBillingAction() == OrderActionType.oatCheckout) {
            this.ctrlBillingDomainOrderCtrl.setOptions([this.newOrder], true);
          }
          else {
            this.ctrlBillingDomainOrderCtrl.setOptions([this.noPurchaseOrder], true);
          }
          this.orderItemsDataSource.data = [];
          this.orderItemsDataSource.data = this.orderItemsDataSource.data;

          switch (this.getBillingType()) {
            case IceTypes.ACCOUNT_TYPE.actPatient: {
              // Fall through and do lookup upon keyword search
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actProvider:
            case IceTypes.ACCOUNT_TYPE.actFacility: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.proSvc.getProviders());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPharmacy: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.pharmSvc.getPharmacies());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actVendor: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.vendorSvc.getVendors());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actPayer: {
              this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.payerSvc.getPayers());
              break;
            }
            case IceTypes.ACCOUNT_TYPE.actSubscriber: {
              // Fall through and do lookup upon keyword search
              break;
            }
            default: {
              // To do error to user
              return;
            }
          }
          break;
        }
      }
    }
    else if (event.autocompleteSettings != null) {
      switch (event.autocompleteSettings.id) {
        case BillingActionNameofDomain: {
          this.updateItemSubmitControls();
          let domObj = this.getBillingDomain();
          if (domObj != null && domObj.length > 0) {
            if (this.getBillingAction() == OrderActionType.oatCheckout)
              this.setBillToOrders(domObj[0].value);
            else
              this.setPurchasesFrom(domObj[0].value);
          }
          break;
        }
        case BillingActionDomainOrder: {
          this.updateItemSubmitControls();

          let ordObj = this.getBillingOrder();
          if (ordObj != null && ordObj.length > 0) {
            if (this.getBillingAction() == OrderActionType.oatCheckout) {
              this.accSvc.getBill(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), ordObj[0].value).subscribe(
                data => {
                  if (data == null || data.length == 0) {
                    return;
                  }

                  let foundBill = data.filter(obj => ordObj[0].value == obj.superbill_charges_key);
                  if (foundBill.length == 0) return;

                  let charges = [];
                  let bill: superbillcharges = <superbillcharges>foundBill[0];
                  if (bill == null) return;

                  for (let ichrg = 0; ichrg < bill.CHARGES.length; ichrg++) {
                    let chrg: medicalservicereference = <medicalservicereference>bill.CHARGES[ichrg];

                    let foundMedSvc = data.filter(obj => obj.medical_service_key == chrg.medical_service_key);
                    if (foundMedSvc.length == 0) continue;

                    let chrgObj = {
                      medical_service_reference_key: chrg.medical_service_reference_key,
                      medical_service_key: chrg.medical_service_key,
                      sub_type: chrg.sub_type,
                      item_abstract: foundMedSvc[0].service_description,
                      quantity: foundMedSvc[0].quantity,
                      price: foundMedSvc[0].price,
                      unit_code: foundMedSvc[0].unit_code,
                      total_amount: foundMedSvc[0].total_amount
                    };
                    charges.push(chrgObj);

                    if (foundMedSvc[0].unit_code != null && foundMedSvc[0].unit_code.length > 0) {
                      this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", foundMedSvc[0].unit_code, "").subscribe(
                        data => {
                          if (data && data.length > 0 && data[0] != null) {
                            chrgObj.unit_code = data[0].title;
                          }
                        },
                        error => {
                          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
                        });
                    }
                  }
                  if (this.orderItemsDataSource.data == null) this.orderItemsDataSource.data = [];
                  this.orderItemsDataSource.data = charges;
                },
                error => {
                  console.log(error);
                });
            }
            else {
              let parts = ordObj[0].value.split(",");
              if (parts < 2) break;

              if (parts[1] != null && parts[1].length > 0) {
                this.accSvc.getPurchaseDelivery(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), parts[1]).subscribe(
                  data => {
                    if (data == null || data.length == 0) {
                      return;
                    }

                    let foundDelivery = data.filter(obj => parts[1] == obj.purchase_delivery_key);
                    if (foundDelivery.length == 0) return;

                    let items = [];
                    let delivery: purchasedelivery = <purchasedelivery>foundDelivery[0];
                    if (delivery == null) return;

                    for (let i = 0; i < delivery.ITEMS.length; i++) {
                      let recv: otheritemsreceiving = <otheritemsreceiving>delivery.ITEMS[i];

                      if (recv.unit_type != null && recv.unit_type.length > 0) {
                        this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", recv.unit_type, "").subscribe(
                          data => {
                            if (data && data.length > 0 && data[0] != null) {
                              recv.unit_type = data[0].title;
                            }
                          },
                          error => {
                            console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
                          });
                      }
                    }
                    if (this.purchaseItemsDataSource.data == null) this.purchaseItemsDataSource.data = [];
                    this.purchaseItemsDataSource.data = delivery.ITEMS;
                  },
                  error => {
                    console.log(error);
                  });
              }
              else if (parts[0] != null && parts[0].length > 0) {
                // To do purchase order lookup
              }
            }
          }
          break;
        }
        case "code_object": {
          let frmNameCtrl = this.invNameCtrl.getFormControl();
          let frmCodeCtrl = this.invCodeCtrl.getFormControl();
          let curNameVal = frmNameCtrl.value;
          let selectedCodeVals = frmCodeCtrl.value;
          if ((curNameVal == null || curNameVal == "") && selectedCodeVals != null && selectedCodeVals.length > 0) {
            try {
              let codeObj = JSON.parse(selectedCodeVals);
              if (codeObj != null && codeObj.length > 0) {
                frmNameCtrl.setValue(codeObj[0].name);
              }
            }
            catch (e) {
              console.log(e);
            }
          }
          break;
        }
      }
    }
    else if (event.autocompleteRemoveSettings != null) {
      switch (event.autocompleteRemoveSettings.id) {
        case BillingActionNameofDomain: {
          this.ctrlBillingDomainOrderCtrl.getFormControl().setValue("");
          if (this.getBillingAction() == OrderActionType.oatCheckout) {
            this.ctrlBillingDomainOrderCtrl.setOptions([this.newOrder], true);
          }
          else {
            this.ctrlBillingDomainOrderCtrl.setOptions([this.noPurchaseOrder], true);
          }
          this.orderItemsDataSource.data = [];
          this.orderItemsDataSource.data = this.orderItemsDataSource.data;
          break;
        }
        case BillingActionDomainOrder: {
          this.orderItemsDataSource.data = [];
          this.orderItemsDataSource.data = this.orderItemsDataSource.data;
          break;
        }
      }
    }
    else if (Iceutility.isdefined(event.autocompleteQuerySettings)) {
      switch (event.autocompleteQuerySettings.id) { // To do: Move this to the new autocompleteQuery event
        case "code_object": {
          if (event["value"] != null && event["value"].length >= 3) {
            let codeQual = this.invCodeQualCtrl.getFormControl().value;
            if (codeQual == "NDC")
              this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, [], false, event["value"]);
            else
              this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, [], false, event["value"]);
          }
          else if (event["value"] != null && event["value"].length == 0) {
            this.appSvc.setCodeList(this.medCodeSvc, new basecode("NDCCODE"), this.invCodeCtrl, [], true);
            this.appSvc.setCodeList(this.medCodeSvc, new basecode("CPTCODE"), this.invCodeCtrl, [], false);
          }
          break;
        }
        case BillingActionNameofDomain: {
          if (event["value"] != null && event["value"].length >= 3) {
            switch (this.getBillingType()) {
              case IceTypes.ACCOUNT_TYPE.actPatient: {
                this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.domainSvc.getPatientsByKeyword(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
                break;
              }
              case IceTypes.ACCOUNT_TYPE.actSubscriber: {
                this.appSvc.setDomainNameList(this.ctrlBillingDomainNameCtrl, true, this.domainSvc.getSubscribersByKeyword(this.appSvc.getCurrentAccountType(), this.appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
                break;
              }
            }
          }
          break;
        }
      }
    }
    else if (Iceutility.isdefined(event.keydownEnterSettings)) {
      switch (event.keydownEnterSettings.columnName) {
        case "quantity":
        case "cost":{
          let actionType = this.getBillingAction();
          let ordObj = this.getBillingOrder();
          let billkey = ""
          if (ordObj != null && ordObj.length > 0)
            billkey = ordObj[0].value;

          if (actionType == OrderActionType.oatCheckout) {
            let itemParams = {
              itemkey: event.tableRowData["medical_service_key"],
              quantity: Iceutility.toDouble(event.currentTarget.value),
            };

            this.accSvc.billServiceScanItemQuantity(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
              data => {
                if (data == null || data.length == 0) return;
              },
              error => {
                // To do, log error
              });
          }
          else {
            let itemParams = {
              recvkey: event.tableRowData["other_items_receiving_key"],
            };

            if (event.keydownEnterSettings.columnName == "quantity") {
              itemParams["quantity"] = Iceutility.toDouble(event.currentTarget.value);
              this.accSvc.itemReceivingScanItemQuantity(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
                data => {
                  if (data == null || data.length == 0) return;
                },
                error => {
                  // To do, log error
                });
            }
            else {
              itemParams["cost"] = Iceutility.toDouble(event.currentTarget.value);
              this.accSvc.itemReceivingScanItemCost(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
                data => {
                  if (data == null || data.length == 0) return;
                },
                error => {
                  // To do, log error
                });
            }
          }
          break;
        }
      }
    }
  }

  private processItemEntry(itemNo: string, itemkey: string): boolean {
    if ((itemNo == null || itemNo.length == 0)
      && (itemkey == null || itemkey.length == 0)) return false;

    let actionType = this.getBillingAction();
    let domBillType = this.getBillingType();
    let domBillObj = this.getBillingDomain();
    let ordObj = this.getBillingOrder();

    let billkey = "", bill = "";
    if (ordObj != null && ordObj.length > 0)
      billkey = ordObj[0].value;

    if (domBillObj != null && domBillObj.length > 0)
      bill = domBillObj[0].value;

    if (actionType == OrderActionType.oatCheckout) {
      let billParams = {
        billtotype: domBillType,
        billto: bill,
        itemkey: itemkey, // base_code_key (service) or other_item_key (inventory)
        itemno: itemNo,
        codekey: "",
        codetype: "",
        quantity: 1.0,
      };

      this.accSvc.billServiceScan(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, billParams).subscribe(
        data => {
          if (data == null || data.length == 0) return;

          // Clear Entry
          let itemEntryFrm = this.ctrlBillingDomainItemEntryCtrl.getFormControl();
          if (itemEntryFrm != null)
            itemEntryFrm.setValue("");

          let bill: superbillcharges = null;

          // Show Item on order
          let foundBill = data.filter(obj => "SUPERBILL_CHARGES" == obj.gettablename());
          if (foundBill.length > 0) {
            bill = foundBill[0];
          }

          if (bill == null) {
            // To do error
            return;
          }

          let mSvc: medicalservice = null;
          let foundmSvc = data.filter(obj => "MEDICAL_SERVICE" == obj.gettablename());
          if (foundmSvc.length > 0) {
            mSvc = foundmSvc[0];
          }

          if (mSvc == null) {
            // To do error
            return;
          }

          let newMSvcRef: medicalservicereference = null;
          let foundmSvcRef = bill.CHARGES.filter(obj => obj.medical_service_key == mSvc.medical_service_key);
          if (foundmSvcRef.length == 0) {
            // To do error
            return;
          }

          newMSvcRef = foundmSvcRef[0];
          let mObj = {
            medical_service_reference_key: newMSvcRef.medical_service_reference_key,
            medical_service_key: mSvc.medical_service_key,
            sub_type: newMSvcRef.sub_type,
            item_abstract: mSvc.service_description,
            quantity: mSvc.quantity,
            price: mSvc.price,
            unit_code: mSvc.unit_code,
            total_amount: mSvc.total_amount
          };

          if (mSvc.unit_code != null && mSvc.unit_code.length > 0) {
            this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", mSvc.unit_code, "").subscribe(
              data => {
                if (data && data.length > 0 && data[0] != null) {
                  mObj.unit_code = data[0].title;
                }
              },
              error => {
                console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
              });
          }

          let tempData = this.orderItemsDataSource.data;

          if (tempData == null) tempData = [];
          tempData.push(mObj);
          this.orderItemsDataSource.data = tempData;
          // Update current order, if necessary
        },
        error => {
          // To do, log error
        });
    } else {
      let purchaseParams = {
        orderfromtype: domBillType,
        orderfrom: bill,
        itemkey: itemkey,
        itemno: itemNo,
        pokey: "",
        ponum: "",
        quantity: 1.0,
      };

      this.accSvc.itemReceivingScan(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, purchaseParams).subscribe(
        data => {
          if (data == null || data.length == 0) return;

          // Clear Entry
          let itemEntryFrm = this.ctrlBillingDomainItemEntryCtrl.getFormControl();
          if (itemEntryFrm != null)
            itemEntryFrm.setValue("");

          let recv: otheritemsreceiving = null;
          let foundrecv = data.filter(obj => "OTHER_ITEMS_RECEIVING" == obj.gettablename());
          if (foundrecv.length > 0) {
            recv = foundrecv[0];
          }

          if (recv == null) {
            // To do error
            return;
          }

          let item: otheritems = null;
          let founditem = data.filter(obj => "OTHER_ITEMS" == obj.gettablename());
          if (founditem.length > 0) {
            item = founditem[0];
          }

          if (item == null) {
            // To do error
            return;
          }

          if (recv.unit_type != null && recv.unit_type.length > 0) {
            this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", recv.unit_type, "").subscribe(
              data => {
                if (data && data.length > 0 && data[0] != null) {
                  recv.unit_type = data[0].title;
                }
              },
              error => {
                console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
              });
          }

          let tempData = this.purchaseItemsDataSource.data;

          if (tempData == null) tempData = [];
          tempData.push(recv);
          this.purchaseItemsDataSource.data = tempData;

          let delivery: purchasedelivery = null;

          //// Get Delivery order
          let foundPurchaseDelivery = data.filter(obj => "PURCHASE_DELIVERY" == obj.gettablename());
          if (foundPurchaseDelivery.length > 0) {
            delivery = foundPurchaseDelivery[0];
          }

          if (delivery == null) {
            // To do error
            return;
          }

          // Update current order, if necessary
          let orddesc = Iceutility.isTextDateTime(delivery.created) ? Iceutility.getDateTextEx(delivery.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(delivery.created));
          orddesc += " - " + (delivery.purchase_order_number.length > 0 ? delivery.purchase_order_number : delivery.purchase_delivery_key.substr(0, 10));
          let opt = { value: delivery.purchase_order_key + "," + delivery.purchase_delivery_key, name: orddesc }
          this.ctrlBillingDomainOrderCtrl.setOptions(this.ctrlBillingDomainOrderCtrl.getOptions().concat([opt]));
        },
        error => {
          // To do, log error
        });
    }
    return true;
  }

  onButtonClick(event) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case BillingActionDomainItemSubmit: {
          let itemEntryFrm = this.ctrlBillingDomainItemEntryCtrl.getFormControl();
          if (itemEntryFrm != null)
            this.processItemEntry(itemEntryFrm.value, "");
          break;
        }
        default: {
          // Add New Item to DB
          if (this.appSvc.processEditPanelSectionButtons(this.sectionTagNewItem, event.buttonSettings.id)) {
            let item: otheritems = new otheritems(this.newItem);
            if (this.newItem != null && this.newItem["code_object"] != null && this.newItem["code_object"].length > 0) {
              try {
                let codeObj = JSON.parse(this.newItem["code_object"]);
                if (codeObj != null && codeObj.length > 0) {
                  this.newItem.code = item.code = codeObj[0].value;
                  this.newItem.code_txt = item.code_txt = codeObj[0].name;

                }
              }
              catch (e) {
                console.log(e);
              }
            }

            let codeQuaList = MedicalcodesService.getMedicalCodeTypeList().filter(opt => item.code_list_qualifier_code == opt.name);
            if (codeQuaList.length > 0) {
              item.code_list_qualifier_code = codeQuaList[0].value;
            }

            let unitList = this.invUnitCtrl.getOptions().filter(opt => item.unit_type == opt.name);
            if (unitList.length > 0) {
              item.unit_type = unitList[0].value;
            }

            this.accSvc.addOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), item).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                if (this.newItem == null) return;

                if (this.resultsDataSource.data == null) this.resultsDataSource.data = [];

                let svrItem: otheritems = <otheritems>data[0];
                if (svrItem == null) return;

                this.newItem.other_items_key = svrItem.other_items_key;
                this.resultsDataSource.data.push(this.newItem)
                this.resultsDataSource.data = this.resultsDataSource.data;

                // Reset;
                this.newItem = null;
              },
              error => {
                // To do, log error
              });            
          }
          break;
        }
      }
    }
  }

  public onRowClick(event) {
    //super.onRowClick(event);
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case this.tableTagResults: {
          this.appSvc.showEditPanelSection(this.sectionTagNewItem);
          this.newItem = null; // reset
          this.newItem = new otheritemsindex();
          this.newItem["code_object"] = null; // this is a temp var
          this.newItem.item_stock_num = Iceutility.guid(true).substr(0, 10).toUpperCase();
          this.appSvc.editPanelSectionUpdate(this.sectionTagNewItem, false, this.newItem);
          break;
        }
      }
    }
  }

  searchSubmitClick(event) {
    let currentSearchKeyword = this.getSearchElementValue();
    if (currentSearchKeyword == "" || currentSearchKeyword.length == 0) return;

    this.resultsTable.actionItems = [];
    this.resultsTable.actionItems.push(itemQuickActionEdit);

    let ordObj = this.getBillingOrder();
    if (ordObj != null && ordObj.length > 0)
      this.resultsTable.actionItems.push(itemQuickActionAdd);

    this.accSvc.getOtherItems(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), currentSearchKeyword).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.resultsDataSource.data = [];
          return;
        }

        for (let iresult = 0; iresult < data.length; iresult++) {
          let item: otheritemsindex = data[iresult];
          if (item == null) continue;

          if (item.unit_type != null && item.unit_type.length > 0) {
            this.medCodeSvc.getCodes("QUANTITYUNITOFMEASURE", "", item.unit_type, "").subscribe(
              data => {
                if (data && data.length > 0 && data[0] != null) {
                  item.unit_type = data[0].title;
                }
              },
              error => {
                console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
              });
          }
        }

        if (this.resultsDataSource.data == null) this.resultsDataSource.data = [];
        this.resultsDataSource.data = data;
      },
      error => {
        // To do, log error
      });
  }

  onNetworkItemClick(event) {

  }
  onMatGridRowClick(event) {
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    let actionType = this.getBillingAction();

    if (event.actionItem == null) return;
    if (itemQuickActionAdd.value == event.actionItem.value) {
      if (actionType == OrderActionType.oatCheckout) {
        let item = <otheritemsindex>event["rowData"];
        if (item == null) {
          // To do log error
          return;
        }
        this.processItemEntry(item.item_stock_num, item.other_items_key);
      }
      else {
        let recv = <otheritemsreceiving>event["rowData"];
        if (recv == null) {
          // To do log error
          return;
        }
        this.processItemEntry("", recv.other_items_key);
      }
    }
    else if (itemQuickActionEdit.value == event.actionItem.value) {
      let item = <otheritemsindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      this.router.navigate([this.navSvc.buildRoute("accounting/inventory/item/" + item.other_items_key, false)]);
    }
    else if (ItemActionType.oatRemoveFromOrder == event.actionItem.value) {
      let ordObj = this.getBillingOrder();
      let billkey = ""
      if (ordObj != null && ordObj.length > 0)
        billkey = ordObj[0].value;

      if (actionType == OrderActionType.oatCheckout) {
        let item = <otheritemsindex>event["rowData"];
        if (item == null) {
          // To do log error
          return;
        }
        let itemParams = {
          itemkey: item["medical_service_key"],
        };

        this.accSvc.billServiceScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
          data => {
            this.orderItemsDataSource.data = this.orderItemsDataSource.data.filter(msv => msv.medical_service_key != itemParams.itemkey);
            this.changeDetectorRefs.detectChanges();
          },
          error => {
            // To do, log error
          });
      }
      else {
        let recv = <otheritemsreceiving>event["rowData"];
        if (recv == null) {
          // To do log error
          return;
        }
        let recvParams = {
          recvkey: recv["other_items_receiving_key"],
        };

        this.accSvc.itemReceivingScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, recvParams).subscribe(
          data => {
            this.purchaseItemsDataSource.data = this.purchaseItemsDataSource.data.filter(recv => recv.other_items_receiving_key != recvParams.recvkey);
            this.changeDetectorRefs.detectChanges();
          },
          error => {
            // To do, log error
          });
      }
    }
  }
}
